import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface IRetryUserIdentityMigrationParams {
    ids: string[];
}

export class RetryUserIdentityMigrationRequest extends Request<IRetryUserIdentityMigrationParams, IResult> {
  constructor(params: IRetryUserIdentityMigrationParams) {
    super('retryUserIdentityMigration', params);
  }
}
